module.exports = __webpack_public_path__ + "static/img/20250324185334.571ca4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20250324185334.png
// module id = 5oQo
// module chunks = 1